<div class="ngx-dialog goreact-modal confirm-dialog">
  <div class="goreact-modal-header">
    <h4 class="modal-title"
      [innerHTML]="data.title">
    </h4>
    <button type="button" class="close-btn" (click)="close()" [attr.aria-label]="'common_close' | translate">
      <i class="ficon-app-x"></i>
    </button>
  </div>
  <div class="goreact-modal-body">
    <p [innerHTML]="data.message"></p>
    @if (data.note) {
      <p class="note" [ngClass]="{'warning': data.warningNote}" [innerHTML]="data.note"></p>
    }
  </div>
  <div class="goreact-modal-footer">
    <button class="cancel-button tertiary-btn goreact-btn" mat-button (click)="cancel()">{{ data.cancelText || ('common_cancel' | translate) }}</button>
    <button class="confirm-button goreact-btn" [ngClass]="[(data.confirmStyle || 'primary-btn')]" (click)="confirm()" data-cy="modal-confirm-btn">
      {{ data.confirmText || ('modal-confirm_confirm' | translate) }}
    </button>
  </div>
</div>
